import React from "react"

interface IFactoryProps<Props> {
  type: string | number
  components: Record<string | number, (props: Props) => JSX.Element>
  missingComponent?: () => JSX.Element
  props: Props
}

export function Factory<T = any>({ type, components, missingComponent, props }: IFactoryProps<T>) {
  const Component = components[type] || missingComponent || DefaultMissingComponent

  return <Component {...props} />

  function DefaultMissingComponent() {
    return (
      <div>
        Could not find a component for type {'"'}
        {type}
        {'"'}
      </div>
    )
  }
}
